import { lazy } from 'react';
import { authRoles } from 'app/auth';
import FeatureGuard from 'app/shared-components/FeatureGuard';
import SmsCampaignsLayout from './layouts/SmsCampaignsLayout';

const CampaignsTab = lazy(() => import('./use-cases/Campaigns/CampaignsTab'));
const AudienceTab = lazy(() => import('./use-cases/Audience/AudienceTab'));
const NewCampaignPage = lazy(() => import('./use-cases/NewCampaign/NewCampaignPage'));
const ReUploadAudience = lazy(() => import('./use-cases/ReUploadAudience/ReUploadAudience'));
const SyncAudiencePage = lazy(() => import('./use-cases/SyncAudience/SyncAudiencePage'));
const SyncAudienceResultsPage = lazy(() => import('./use-cases/SyncAudience/SyncAudienceResultsPage'));

const SmsCampaignsConfig = {
  settings: {
    layout: {
      config: {
        topBanner: { display: false },
        footer: { display: false },
        healtheraHeader: {
          display: true,
          options: {
            pharmacySelector: true,
            background: 'marketing',
          },
        },
      },
    },
  },
  auth: authRoles.pharmacist,
  routes: [
    {
      path: 'sms-campaigns',
      element: (
        <FeatureGuard flag="sms_campaigns">
          <SmsCampaignsLayout />
        </FeatureGuard>
      ),
      children: [
        { path: '', element: <CampaignsTab /> },
        { path: 'audience', element: <AudienceTab /> },
      ],
    },
    {
      path: 'sms-campaigns/new-campaign',
      element: (
        <FeatureGuard flag="sms_campaigns">
          <NewCampaignPage />
        </FeatureGuard>
      ),
      settings: {
        layout: {
          config: {
            healtheraHeader: {
              display: true,
              options: {
                // Mounted but hidden so pharmacy selection still initialises on direct page load
                pharmacySelector: true,
                pharmacySelectorHidden: true,
                background: 'marketing',
              },
            },
          },
        },
      },
    },
    {
      path: 'sms-campaigns/:campaignId/re-upload-file',
      element: (
        <FeatureGuard flag="sms_campaigns">
          <ReUploadAudience />
        </FeatureGuard>
      ),
      auth: authRoles.support,
      settings: {
        layout: {
          config: {
            healtheraHeader: {
              display: true,
              options: {
                pharmacySelector: false,
                background: 'marketing',
              },
            },
          },
        },
      },
    },
    {
      path: 'sms-campaigns/sync-audience',
      element: (
        <FeatureGuard flag="sms_campaigns">
          <SyncAudiencePage />
        </FeatureGuard>
      ),
      settings: {
        layout: {
          config: {
            healtheraHeader: {
              display: true,
              options: {
                pharmacySelector: false,
                background: 'marketing',
              },
            },
          },
        },
      },
    },
    {
      path: 'sms-campaigns/sync-audience/results',
      element: (
        <FeatureGuard flag="sms_campaigns">
          <SyncAudienceResultsPage />
        </FeatureGuard>
      ),
      settings: {
        layout: {
          config: {
            healtheraHeader: {
              display: true,
              options: {
                pharmacySelector: false,
                background: 'marketing',
              },
            },
          },
        },
      },
    },
  ],
};

export default SmsCampaignsConfig;
